export default "__VITE_ASSET__CmYlcgDm__"